import { useState } from "react";
import type { Match } from "@/types";

export default function VideoPlayer({ match }: { match: Match }) {
  const [entered, setEntered] = useState(false);

  return (
    <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
      <div className="relative w-full aspect-video bg-primary-950">
        <img
          src={match.cover}
          alt={`${match.home.name} 对阵 ${match.away.name} 直播画面`}
          title={`${match.home.name} vs ${match.away.name} 实时直播 - 篮球直播`}
          className={`absolute inset-0 w-full h-full object-top object-cover transition-opacity duration-500 ${
            entered ? "opacity-40" : "opacity-100"
          }`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/30 to-primary-950/40" />

        {!entered ? (
          <button
            type="button"
            onClick={() => setEntered(true)}
            className="absolute inset-0 flex flex-col items-center justify-center gap-3 cursor-pointer group"
          >
            <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent-500 group-hover:bg-accent-600 flex items-center justify-center transition-colors">
              <i className="ri-play-fill text-3xl md:text-4xl text-background-50 dark:text-foreground-950" />
            </span>
            <span className="text-background-50 text-sm md:text-base font-medium">
              {match.status === "live" ? "点击进入直播间" : "点击观看直播 / 回放"}
            </span>
            <span className="text-primary-200 text-xs">前端演示播放器 · 高清线路</span>
          </button>
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
            <span className="w-14 h-14 rounded-full border-2 border-dashed border-accent-400 flex items-center justify-center">
              <i className="ri-loader-4-line text-2xl text-accent-400 animate-spin" />
            </span>
            <p className="text-background-50 font-heading text-lg">直播线路正在接入，敬请期待</p>
            <p className="text-primary-200 text-xs max-w-md leading-relaxed">
              当前为前端演示播放区域，暂未集成真实视频信号。正式上线后将提供多线路高清直播与实时弹幕互动。
            </p>
            <button
              type="button"
              onClick={() => setEntered(false)}
              className="mt-1 px-4 py-2 rounded-full border border-background-50/30 text-background-50 text-xs hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回封面
            </button>
          </div>
        )}

        {match.status === "live" && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-[11px] font-label font-semibold">
            <span className="bb-live-dot w-1.5 h-1.5 rounded-full bg-background-50 dark:bg-foreground-950" />
            直播中
          </span>
        )}
      </div>
      <div className="px-4 py-3 flex items-center gap-2 bg-background-100">
        <i className="ri-information-line text-accent-600" />
        <p className="text-xs text-foreground-600">
          提示：本区域为前端演示直播播放器，未接入真实视频线路，仅用于展示界面与交互效果。
        </p>
      </div>
    </div>
  );
}